// Country configuration for API requests
export const COUNTRY = process.env.VUE_APP_COUNTRY || 'AR';
